import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { titles } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		boxSizing: 'border-box',
		flexDirection: 'column',
		gap: 20,
		// The surrounding survey body is a flex column with align-items: center, which sizes its
		// children to fit-content rather than stretching them. Without an explicit width the form
		// would be as wide as whatever it happens to contain, so showing or hiding a field resizes
		// the entire page. Filling first lets maxWidth and the auto margins do the centering.
		width: '100%',
		maxWidth: 968,
		margin: '0 auto',
		padding: 16,

		'@media (min-width: 900px)': {
			marginTop: THEME.spacing.lg,
			padding: 0,
		},
	},

	thankYouContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 40,
		width: '100%',
		padding: 16,
	},
	illustrationContainer: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	illustration: {
		width: '100%',
		objectFit: 'contain',

		[`@media (min-width: ${THEME.breakpoints.md}px)`]: {
			width: '100%',
			maxWidth: 500,
		},
	},
	thankYouMessage: {
		fontSize: 24,
		fontWeight: 600,
	},
	processingOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(255, 255, 255, 0.95)',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 20,
		gap: 16,
	},
	processingMessage: {
		fontSize: 18,
		fontWeight: 600,
		color: titles,
		textAlign: 'center',
	},
	thankYouButtonContainer: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	thankYouButton: {
		width: 400,
	},
	thankYouMessageContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
